module.exports = __webpack_public_path__ + "static/media/analytics.e23e0377.svg";